import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  HostListener,
} from '@angular/core';
import { UserService } from '../../../services/user.service';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { StorageService } from '../../../services/storage.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { gapi } from 'gapi-script';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  @Input() isSidebarOpen: boolean = false;
  @Output() toggleSidebarEvent = new EventEmitter<void>();
  username: string | null = null;
  user: any = null;
  plan: any = null;
  isDropdownOpen = false;

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit(): void {
    // Keep subscription plan updated in navbar
    this.subscriptionService.getSubscriptionObservable().subscribe({
      next: (plan) => {
        this.plan = plan;
        console.log('navbar.component.ts [plan updated]:', plan);
      },
      error: (err) => console.error('Failed to load plan in navbar', err),
    });

    this.fetchUsername();
  }

  private fetchUsername() {
    this.userService.getCurrentUser().subscribe({
      next: (response) => {
        this.user = response;
        this.username = response.name;
        console.log('navbar.component.ts [f05119] : ', response);
      },
      error: (error) => console.error('Error fetching username', error),
    });
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  upgradePlan() {
    this.router.navigate(['/subscription']);
  }

  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (
      !event.target ||
      !(event.target as HTMLElement).closest('#profile-dropdown')
    ) {
      this.isDropdownOpen = false;
    }
  }

  getDaysLeft(): number {
    if (!this.plan?.end_date) {
      return 0; // No end date available
    }

    const endDate = new Date(this.plan?.end_date); // Parse string to Date
    const today = new Date(); // Current date

    const differenceInTime = endDate.getTime() - today.getTime(); // Difference in milliseconds
    const differenceInDays = Math.ceil(
      differenceInTime / (1000 * 60 * 60 * 24)
    ); // Convert to days

    return differenceInDays > 0 ? differenceInDays : 0; // Return only positive days
  }

  logout(): void {
    try {
      const auth2 = gapi.auth2.getAuthInstance();
      if (auth2) {
        // Sign out from Google session
        auth2.signOut().then(() => {
          // Disconnect to clear cached consent and force account picker
          auth2.disconnect();
          console.log('Google session cleared, account picker will be shown next time.');
        });
      }
    } catch (err) {
      console.warn('Google Auth instance not found during logout', err);
    }

    // Clear all app-related data
    this.authService.clearAuthData();
    this.authService.clearSubscription();
    this.storageService.clearcancelledTrialBanner();

    // Navigate to login page
    this.router.navigate(['/auth']);
  }

  toggleSidebar() {
    this.toggleSidebarEvent.emit();
  }
}
